"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _sorting = require("../../../utils/sorting");

class FilterListRenderProps extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleChange", ({
      target
    }) => {
      const {
        value
      } = target;

      if (value !== this.state.searchString) {
        this.setState({
          searchString: `${value}`
        });
      }
    });
    this.state = {
      searchString: '',
      filteredData: props.data
    };
    this.handleSearchChange = (0, _lodash.default)(this.updateFilteredData, 300).bind(this);
    this.inputRef = /*#__PURE__*/_react.default.createRef();
  }

  componentDidUpdate(prevProps, {
    searchString
  }) {
    if (searchString !== this.state.searchString) {
      this.handleSearchChange(this.state.searchString);
    }
  }

  clearInput() {
    this.inputRef.current.value = '';
  }

  updateFilteredData(searchString) {
    const filteredData = (0, _sorting.filterList)(searchString, this.props.filterKey, this.props.data);
    this.setState({
      searchString,
      filteredData
    }, () => {
      const {
        onChange
      } = this.props;

      if (typeof onChange === 'function') {
        onChange(this.state);
      }
    });
  }

  render() {
    return this.props.children({
      onChange: this.handleChange,
      searchString: this.state.searchString,
      rawData: this.props.data,
      rawLength: this.props.data.length,
      data: this.state.filteredData,
      dataLength: this.state.filteredData.length,
      inputRef: this.inputRef
    });
  }

}

(0, _defineProperty2.default)(FilterListRenderProps, "propTypes", {
  onChange: _propTypes.default.func,
  filterKey: _propTypes.default.string.isRequired
});
(0, _defineProperty2.default)(FilterListRenderProps, "defaultProps", {
  onChange: undefined
});
var _default = FilterListRenderProps;
exports.default = _default;
module.exports = exports.default;